import BaseModel from "./BaseModel";

export enum InAppMessagePresentation {
    HomeTab = 'home_tab',
}

export default class InAppMessage extends BaseModel {
  id: number;
  toAccountId: number;
  title: string;
  shortBody?: string;
  longBody: string;
  presentation: InAppMessagePresentation;
  showPopup: boolean;
  sentAt: Date;
  viewedAt?: Date;
  dismissedAt?: Date;
  expiresAt?: Date;

  static __dates = ["sentAt", "viewedAt", "dismissedAt", "expiresAt"];

  constructor(data: any) {
    super(data, InAppMessage.__dates);
    this.id = data.id;
    this.toAccountId = data.toAccountId;
    this.title = data.title;
    this.shortBody = data.shortBody;
    this.longBody = data.longBody;
    this.presentation = data.presentation;
    this.showPopup = data.showPopup;
    this.sentAt = this.__get('sentAt');
    this.viewedAt = this.__get('viewedAt');
    this.dismissedAt = this.__get('dismissedAt');
    this.expiresAt = this.__get('expiresAt');
  }
}
